import { render, staticRenderFns } from "./historialTendero.vue?vue&type=template&id=2cdcc1e4&scoped=true"
import script from "./historialTendero.vue?vue&type=script&lang=js"
export * from "./historialTendero.vue?vue&type=script&lang=js"
import style0 from "./historialTendero.vue?vue&type=style&index=0&id=2cdcc1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdcc1e4",
  null
  
)

export default component.exports